export default "__VITE_ASSET__cpDgqyCt__"